<template>
	<el-row :gutter="20">
		<SelectPicture />
	</el-row>
</template>

<script>
	import SelectPicture from '../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture
		},
		data() {
			return {
				inputValue: '',
				isShow: false
			}
		},
		methods: {}
	}
</script>

<style scoped>

</style>
4
